import axios from 'axios';
import { getLang, getCountry } from './v1UpdateDate';

/**
 * TopページNews表示用JSONデータを取得する。
 * @return {Promise}
 */
const getNewsJsonData = () => {
  return axios
    .get(`/japan-travel-planner/common/js/news.json`)
    .then(response => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

const appendElement = (baseEle, childTagStr) => {
  const tempEle = document.createElement('div');
  tempEle.innerHTML = childTagStr;
  const targetEle = tempEle.firstElementChild;
  baseEle.appendChild(targetEle);
  return targetEle;
};

const appendNewsHeader = (baseEle, headerStr) => {
  const titleTag = `
    <div class="v1-top-news-header">${headerStr}</div>
  `;
  return appendElement(baseEle, titleTag);
};

const appendNewsMainTag = baseEle => {
  const mainTag = `
    <div class="v1-top-news-main" />
  `;
  return appendElement(baseEle, mainTag);
};

const appendNews = (baseEle, news) => {
  const newsTag = news.url
    ? `
    <div class="v1-top-news-container v1-top-news-link">
      <a rel="noreferrer noopener" href="${news.url}">
        <div class="v1-top-news-date">${news.date}</div>
        <div class="v1-top-news-title">${news.title}</div>
      </a>
    </div>
  `
    : `
    <div class="v1-top-news-container">
      <div class="v1-top-news-date">${news.date}</div>
      <div class="v1-top-news-title">${news.title}</div>
    </div>
  `;
  appendElement(baseEle, newsTag);
};

const getNewsObject = (newsOfThisSite, index) => {
  if (newsOfThisSite && newsOfThisSite[`title${index}`] && newsOfThisSite[`date${index}`]) {
    return {
      title: newsOfThisSite[`title${index}`],
      date: newsOfThisSite[`date${index}`],
      url: newsOfThisSite[`url${index}`],
    };
  }
  return null;
};

const getNewsList = newsOfThisSite => {
  const maxCount = Number(newsOfThisSite.maxCount) ? Number(newsOfThisSite.maxCount) : 5;
  const list = [];
  Array.from({ length: maxCount }).forEach((_, i) => {
    const newsObject = getNewsObject(newsOfThisSite, i + 1);
    if (newsObject) {
      list.push(newsObject);
    }
  });
  return list;
};

const v1TopNewsMain = async () => {
  const lang = getLang();
  const country = getCountry();
  const newsData = await getNewsJsonData();
  if (!newsData || newsData.length <= 0) {
    return;
  }
  // お知らせ表示を実施するroot要素
  const topNewsRootEle = document.getElementById('v1-top-news');
  if (!topNewsRootEle) return;
  // このサイトの国情報、言語に合致するNews情報を抽出
  const newsOfThisSite = newsData.find(row => {
    return row.langCode === lang && row.countryCode === country;
  });
  const newsList = getNewsList(newsOfThisSite);
  // 掲載するNewsがあれば画面に表示実施
  if (newsList.length > 0) {
    topNewsRootEle.setAttribute('class', '');
    if (lang === 'ja' || lang === 'ko' || lang === 'zh') {
      topNewsRootEle.setAttribute('class', 'large-lang');
    }
    appendNewsHeader(topNewsRootEle, newsOfThisSite.heading);
    const newsMainEle = appendNewsMainTag(topNewsRootEle);
    newsList.forEach(news => {
      appendNews(newsMainEle, news);
    });
  }
};

export default function v1TopNews() {
  v1TopNewsMain();
}
